<mat-card class="personnel-card" *ngIf="personnel">
    <mat-card-title>Personnel Details</mat-card-title>
    <mat-divider></mat-divider>
    <mat-card-content>
      <div class="details-grid">
        <div><strong>Full Name:</strong> {{ personnel.full_name }}</div>
        <div><strong>Role:</strong> {{ personnel.role }}</div>
        <div><strong>Specialization:</strong> {{ personnel.specialization }}</div>
        <div><strong>Email:</strong> {{ personnel.contact_email }}</div>
        <div><strong>Phone:</strong> {{ personnel.contact_phone }}</div>
        <div><strong>Department:</strong> {{ personnel.department }}</div>
        <div><strong>Employee Code:</strong> {{ personnel.employee_code || 'N/A' }}</div>
        <div><strong>Role ID:</strong> {{ personnel.role_id || 'N/A' }}</div>
        <div><strong>Active:</strong> {{ personnel.is_active ? 'Yes' : 'No' }}</div>
        <div><strong>Last Login:</strong> {{ personnel.last_login || 'Never' }}</div>
      </div>
    </mat-card-content>
  </mat-card>
  